module.exports = __webpack_public_path__ + "assets/img/96.83cbaa2e.png";